import { Box, Button, Typography } from '@mui/material'
import React, { useState } from 'react'
import BackButton from '../../common/BackButton'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import { ensureFunds, saveDraft, updatePortfolio } from '../../../store/actions/createPortfolio';
import FundSummaryContent from './FundSummaryContent';

const FundSummaryStep: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const [loading, setLoading] = useState(false);

    const onConfigure = () => {
        setLoading(true);
        dispatch(ensureFunds()).then(() => {
            navigate((id !== undefined ? AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", id) : AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE).replace(":step", '6'));
        });
    }

    const onSaveDraft = () => {
        setLoading(true);
        dispatch(saveDraft()).then(() => {
            navigate(AUTHENTICATED_ROUTES.PORTFOLIOS_CONFIRM_SAVE_ROUTE.replace(":confirmSave", "saved"));
        })
    }
    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} alignItems={"center"} gap={"24px"}>
            <BackButton />
            <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>{t('CreatePortfolioPortfolioSummary')}</Typography>
        </Box>
        <FundSummaryContent />
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' disabled={loading} onClick={onConfigure}>{t('CreatePortfolioButtonSubmit')}</Button>
            <Button variant='outlined' disabled={loading} onClick={onSaveDraft}>{t('CreatePortfolioButtonSaveAsDraft')}</Button>
            <Button variant='text' disabled={loading} onClick={onSaveDraft}>{t('CreatePortfolioButtonDownloadPDF')}</Button>
        </Box>
    </Box>
}

export default FundSummaryStep